import { ReactNode, useContext, useRef, useState } from "react";
import { SpinnerContext } from "../context/spinnerContext";
import { swalPopUp } from "../utils/swal";

type TFormValues = {
    nombre: string;
    whatsapp: string;
    tipoInstalacion: string;
    mensaje: string;
}

export default function ContactForm() {
    const { showSpinner } = useContext(SpinnerContext);
    const [captcha, setCaptcha] = useState<ReactNode | null>(null);
    const formRef = useRef<HTMLFormElement | null>(null);

    const validateForm = async () => {

        const formData = new FormData(formRef.current as HTMLFormElement);
        const data = Object.fromEntries(formData) as TFormValues;

        if (data.nombre.trim() !== "" && data.whatsapp.trim() !== "" && data.mensaje.trim() !== "") {
            sendForm();
        } else {
            swalPopUp("Ops!", "Falta Ingresar Algún Dato", "warning");
        }
    }

    const sendForm = async () => {

        setCaptcha(null)

        const formData = new FormData(formRef.current as HTMLFormElement);
        const data = Object.fromEntries(formData) as TFormValues;

        try {
            showSpinner(true);
            const respJSON = await fetch("/sendmail.php", {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                }
            })

            const respOBJ = await respJSON.json();
            showSpinner(false);
            if (respOBJ.msg.includes("Error")) {
                swalPopUp("Ops!", `${respOBJ.msg}, Intente otra vez`, "error");
            } else {
                const inputs: NodeListOf<HTMLInputElement> = document.querySelectorAll(".inputForm");
                inputs.forEach((input) => input.value = "");
                swalPopUp("Enviado!", "Mensaje enviado con éxito, gracias por contactarnos!", "success");
            }

        } catch (err: unknown) {
            showSpinner(false);
            swalPopUp("Ops!", err instanceof Error ? `Error al enviar el mensaje: ${err.message}` : `Error al enviar el mensaje: problema desconocido`, "error");
        }
        document.body.style.overflow = "initial";
    }

    return (
        <>
            {captcha}
            <section className="buzon6-contact" id="contacto">
                <div className="buzon6-container">
                    <div className="buzon6-contact-card">
                        <div className="buzon6-contact-copy">
                            <h2>Solicitá tu presupuesto</h2>
                            <p>
                                Contanos dónde querés instalarlo y qué color o terminación te
                                interesa. Te respondemos con asesoramiento para definir el modelo
                                ideal para tu casa, comercio u oficina.
                            </p>
                        </div>

                        <form action="" className="buzon6-form" ref={formRef}>
                            <div className="buzon6-form-row">
                                <input type="text" placeholder="Nombre" name="nombre" className="inputForm" />
                                <input type="email" placeholder="WhatsApp" name="whatsapp" className="inputForm" />
                            </div>
                            <input
                                type="text"
                                placeholder="Lugar de instalación: reja, portón, puerta o pared"
                                name="tipoInstalacion"
                                className="inputForm"
                            />
                            <textarea
                                placeholder="Mensaje: medidas aproximadas, color deseado o consulta"
                                rows={6}
                                name="mensaje"
                                className="inputForm"
                            />
                            <button
                                type="button"
                                className="buzon6-btn buzon6-btn-primary buzon6-form-submit"
                                onClick={validateForm}
                            >
                                Enviar consulta
                            </button>
                        </form>
                    </div>
                </div>
            </section>
        </>)

}